<script lang="ts" setup>
	import AvailabilityExportComponent from '@/components/generic/AvailabilityExportComponent.vue';
	import {storeToRefs} from 'pinia';
	import {useAppStore} from '@/store/app.store';

	const {exportModalActive} = storeToRefs(useAppStore());
</script>

<template>
	<div class="catalog-overview-header__export">
		<button class="button button--white button--small" @click="exportModalActive = true">
			{{ $t('site.products.overview.header.availability.export.button.text') }}
		</button>
	</div>

	<Teleport to=".catalog-body">
		<div class="catalog-export-modal modal" v-if="exportModalActive">
			<div class="catalog-export-modal__inner">
				<button @click.prevent="exportModalActive = false"
				        type="button" class="catalog-modal__close">
					<svg class="icon-modal-close" width="20" height="20">
						<use xlink:href="/assets/images/build/svg-sprite.min.svg#modal-close"></use>
					</svg>
				</button>

				<div class="catalog-modal">
					<AvailabilityExportComponent />
				</div>
			</div>
		</div>
	</Teleport>
</template>
